import { useEffect, useRef } from "react";
import { getToken } from "../lib/api";

export function useRealtime(onEvent) {
  const wsRef = useRef(null);
  const cb = useRef(onEvent);
  cb.current = onEvent;

  useEffect(() => {
    let closed = false;
    let retry;
    const connect = () => {
      const token = getToken();
      if (!token) return;
      const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
      let ws;
      try { ws = new WebSocket(`${base}/api/ws?token=${token}`); } catch { return; }
      wsRef.current = ws;
      ws.onmessage = (e) => { try { const msg = JSON.parse(e.data); cb.current && cb.current(msg); } catch {} };
      ws.onclose = () => { if (!closed) retry = setTimeout(connect, 5000); };
      ws.onerror = () => { try { ws.close(); } catch {} };
    };
    connect();
    return () => { closed = true; clearTimeout(retry); try { wsRef.current && wsRef.current.close(); } catch {} };
  }, []);
}

export function liveSocket(liveId, onEvent) {
  const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
  let ws;
  try { ws = new WebSocket(`${base}/api/ws/live/${liveId}`); } catch { return null; }
  ws.onmessage = (e) => { try { onEvent(JSON.parse(e.data)); } catch {} };
  return ws;
}
